import type { RefresherEventDetail } from '@ionic/react'
import { useCallback } from 'react'

type IonRefresherEvent = CustomEvent<RefresherEventDetail>

/** `refetch` must resolve when the query settles (CRE-102). */
export const useIonicRefresher = (refetch: () => Promise<unknown>) => {
  const onRefresh = useCallback(
    async (event: IonRefresherEvent) => {
      try {
        await refetch()
      } catch (error) {
        // must not reject out of an Ionic event handler
        console.error('pull-to-refresh failed', error)
      } finally {
        event.detail.complete()
      }
    },
    [refetch],
  )

  return { onRefresh }
}
